import { Component, OnInit } from '@angular/core';
import { EaccessAuthService } from '../../auth/eaccess-auth.service';
import { ROLE_AUDIT_TRAIL_MONTHLY_STATEMENTS_DISTRIBUTION_READ } from '../../shared/constants';

@Component({
  selector: 'eaa-can-view-audit-trail-monthly-statements-distribution',
  template: `
    @if (canView) {
      <ng-content></ng-content>
    }
  `
})
export class CanViewAuditTrailMonthlyStatementsDistributionComponent implements OnInit {
  public canView: boolean | null = null;

  constructor(private authService: EaccessAuthService) {}

  public ngOnInit(): void {
    this.authService
      .hasRole$(ROLE_AUDIT_TRAIL_MONTHLY_STATEMENTS_DISTRIBUTION_READ)
      .subscribe((hasRole) => (this.canView = hasRole));
  }
}
